import Skeleton from '@/components/ui/Skeleton'
import { cn } from '@/lib/utils'
import {
  STAT_GRID_CELL,
  STAT_GRID_COLUMNS,
  type StatGridColumns,
} from '@/screens/stock/components/overview/stat-grid-variants'

/**
 * The grid before its figures land, on the loaded cell's own lines: the
 * `body-xs` label (a 16px box), the `h-m` figure (22px, a 24px box) and,
 * with `withSub`, the `body-xs` line under it.
 *
 * Its own light module (Skeleton, `cn` and the shared classes only), the way
 * `StatStripSkeleton` is: the Stock route's pending page draws it, and a
 * `pendingComponent` ships in the entry chunk, so it may not pull StatGrid's
 * component module (and with it StatStrip) in.
 */
export default function StatGridSkeleton({
  cells,
  columns,
  withSub = false,
}: {
  cells: number
  columns: StatGridColumns
  withSub?: boolean
}) {
  return (
    <div aria-hidden="true" className="@container overflow-hidden">
      <div className={cn('-my-4 grid', STAT_GRID_COLUMNS[columns])}>
        {Array.from({ length: cells }, (_, index) => (
          <div key={index} className={cn('flex min-w-0 flex-col gap-1', STAT_GRID_CELL)}>
            <div className="flex h-4 items-center">
              <Skeleton className="h-3 w-20 rounded-xs" />
            </div>
            <div className="flex h-6 items-center">
              <Skeleton className="h-4 w-24 rounded-xs" />
            </div>
            {withSub ? (
              <div className="flex h-4 items-center">
                <Skeleton className="h-3 w-28 rounded-xs" />
              </div>
            ) : null}
          </div>
        ))}
      </div>
    </div>
  )
}
